import { SizableText, YStack } from 'tamagui'
import { DesignSystem } from '@/src/design-system'

export function InReview({ isUpdate }: { isUpdate: boolean }) {
  return (
    <DesignSystem.Card>
      <YStack gap="$2" flex={1}>
        <SizableText fontWeight={700}>Reviewing Your Mortgage Statement</SizableText>
        <SizableText size="$3">
          Mesa must verify your mortgage statement before your{isUpdate ? ' updated' : ''} mortgage
          rewards become active.
        </SizableText>
      </YStack>
    </DesignSystem.Card>
  )
}
